import { useEffect, useState } from "react";
import { getRestrictedBrands } from "./requests";

export const useGetRestrictedBrands = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [restrictedBrands, setRestrictedBrands] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const response = await getRestrictedBrands();
        setRestrictedBrands(response);
      } catch (error) {
        setRestrictedBrands(null);
      } finally {
        setIsLoading(false);
      }
    };
    void getData();
  }, []);

  return {
    isLoading,
    restrictedBrands
  };
};
